import BaseEntity from './BaseEntity';
export default class RepositoryToken extends BaseEntity {
    constructor(data) {
        super();
        this.lastUsed = null;
        this.id = this.parseProperty(data, 'id');
        this.createdAt = this.parseProperty(data, 'createdAt');
        this.expiration = this.parseProperty(data, 'expiration');
        this.lastUsed = this.parseProperty(data, 'lastUsed');
        this.token = this.parseProperty(data, 'token');
        this.new = 'new' in data ? this.parseProperty(data, 'new') : false;
    }
    getToken() {
        if (this.new) {
            return this.token;
        }
        return `${this.token.slice(0, 4)}${this.token.slice(4, this.token.length - 4).replace(/./g, '*')}${this.token.slice(this.token.length - 4)}`;
    }
    setToken(token) {
        this.token = token;
    }
    setNew(isNew) {
        this.new = isNew;
    }
    setExpiration(expirationDate) {
        this.expiration = expirationDate.toString();
    }
}
